import { Button } from "@/components/ui/button";
import { Instagram, MessageCircle, Mail } from "lucide-react";

export default function ComingSoon() {
  return (
    <main
      data-testid="coming-soon-page"
      className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden"
      style={{ background: "#FCF8F6" }}
    >
      {/* Decorative background circles */}
      <div
        className="absolute top-[-20%] right-[-10%] w-[500px] h-[500px] rounded-full opacity-20"
        style={{ background: "#A3B18A" }}
      />
      <div
        className="absolute bottom-[-15%] left-[-8%] w-[400px] h-[400px] rounded-full opacity-15"
        style={{ background: "#F0B7A4" }}
      />

      <div className="relative z-10 text-center px-6 max-w-2xl mx-auto">
        {/* Logo */}
        <img
          src="https://customer-assets.emergentagent.com/job_zumo-fresh-juice/artifacts/b5i6fq4z_WhatsApp%20Image%202026-04-15%20at%205.21.42%20PM.jpeg"
          alt="The Zumo Company"
          className="h-32 w-32 rounded-full object-cover mx-auto mb-10"
          data-testid="coming-soon-logo"
        />

        {/* Tagline */}
        <p
          className="text-xs uppercase tracking-[0.3em] font-semibold mb-6"
          style={{
            fontFamily: "'Manrope', sans-serif",
            color: "#A3B18A",
          }}
        >
          Cold Pressed Juices & Wellness Shots
        </p>

        {/* Heading */}
        <h1
          className="text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tighter leading-none mb-6"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            color: "#283618",
          }}
        >
          Something Fresh
          <br />
          <span style={{ color: "#F0B7A4" }}>Is Brewing</span>
        </h1>

        {/* Subtext */}
        <p
          className="text-base md:text-lg leading-relaxed mb-4 max-w-md mx-auto"
          style={{
            fontFamily: "'Manrope', sans-serif",
            color: "#6F5E58",
          }}
        >
          Our new website is on its way. In the meantime, you can still
          order your favourite cold-pressed juices.
        </p>

        <p
          className="text-sm font-semibold mb-10"
          style={{
            fontFamily: "'Manrope', sans-serif",
            color: "#283618",
          }}
        >
          No Sugar. No Water. No Preservatives.
        </p>

        {/* CTA */}
        <a
          href="https://wa.me/97466846261?text=Hi%2C%20I'd%20like%20to%20place%20an%20order"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            data-testid="coming-soon-order-btn"
            className="rounded-full px-10 py-3.5 text-sm font-semibold uppercase tracking-wider transition-all duration-300 hover:scale-105 mb-12"
            style={{
              background: "#283618",
              color: "#FCF8F6",
              fontFamily: "'Manrope', sans-serif",
            }}
          >
            Order on WhatsApp
          </Button>
        </a>

        {/* Social Links */}
        <div className="flex items-center justify-center gap-5">
          <a
            href="https://www.instagram.com/thezumocompany/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="coming-soon-instagram"
            className="w-11 h-11 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ background: "rgba(40, 54, 24, 0.08)" }}
          >
            <Instagram size={18} color="#283618" />
          </a>
          <a
            href="https://wa.me/97466846261"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="coming-soon-whatsapp"
            className="w-11 h-11 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ background: "rgba(40, 54, 24, 0.08)" }}
          >
            <MessageCircle size={18} color="#283618" />
          </a>
          <a
            href="mailto:contact@thezumocompany.com"
            data-testid="coming-soon-email"
            className="w-11 h-11 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ background: "rgba(40, 54, 24, 0.08)" }}
          >
            <Mail size={18} color="#283618" />
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="absolute bottom-6 text-center">
        <p
          className="text-[11px]"
          style={{
            fontFamily: "'Manrope', sans-serif",
            color: "rgba(111, 94, 88, 0.5)",
          }}
        >
          &copy; {new Date().getFullYear()} The Zumo Company. Doha, Qatar.
        </p>
      </div>
    </main>
  );
}
